import { Body1 } from "@material/react-typography";
import React from "react";
import "./EmptyPlaceholder.scss";

export const EmptyPlaceholder: React.FC<{ text: string }> = ({ text }) => (
  <Body1 className="empty-placeholder">({text})</Body1>
);
